import {
  PaymentPlanType,
  PlanType,
  UserRoleType,
} from '../../../constants/types';

export const PAGE_TITLE_MSG =
  'Improve Patient Care and Increase Your Workflow.';
export const PATIENT_PAGE_TITLE_MSG = 'Take Control Of Your Urinary Health.';
export const DOCTOR_PAGE_TITLE_MSG =
  'Take Control Of Your Patients Urinary Health.';

export const GET_PAGE_TITLE_BY_ROLE_MSG = (role?: UserRoleType): string => {
  switch (role) {
    case 'PATIENT':
      return PATIENT_PAGE_TITLE_MSG;
    case 'DOCTOR':
      return DOCTOR_PAGE_TITLE_MSG;
    default:
      return PAGE_TITLE_MSG;
  }
};

export const GET_PLAN_TYPES_FOR_USER_ROLE = (
  role?: UserRoleType,
): PlanType[] => {
  switch (role) {
    case 'PATIENT':
      return ['PATIENT'];
    case 'DOCTOR':
      return ['SINGLE_PROVIDER'];
    case 'CLINIC':
      //uncomment when the problem with group subscriptions is resolved
      return [
        undefined /*'GROUP'*/,
        /*'DEMO'*/
      ];
    case 'ADMIN':
      return ['SINGLE_PROVIDER', 'PATIENT'];
    default:
      return [];
  }
};

export const GET_USER_ROLE_TYPE_BY_PLAN_NAME = (planId: string): PlanType => {
  return planId.includes('DOCTOR')
    ? 'SINGLE_PROVIDER'
    : planId.includes('PATIENT')
    ? 'PATIENT'
    : planId.includes('GROUP')
    ? 'GROUP'
    : planId.includes('DEMO')
    ? 'DEMO'
    : undefined;
};

export const GET_IS_PAID_PLAN = (planGroupType: PlanType): boolean => {
  return planGroupType !== 'DEMO';
};

export const GET_PATIENT_PLAN_GROUP_DESCRIPTION = (): string => {
  return (
    'Includes access to personal monitoring dashboard and MenHealth® and Sunrise®.\n' +
    'Share accurate test results with your doctor to help diagnose and manage your urinary health.'
  );
};

export const GET_SINGLE_PROVIDER_PLAN_GROUP_DESCRIPTION = (
  planDescriptions: string[],
): string => {
  return `Our core product designed for urologists and urology clinics to improve workflow and patient engagement and care.\n\n${planDescriptions.join(
    '\n',
  )}`;
};

export const GET_CLINICS_PLAN_GROUP_DESCRIPTION = (
  planDescriptions: string[],
): string => {
  return `Customized product to fit your practice needs for multiple doctors and multiple locations.\n
          Additional add-ons, EMR integrations, 24/7 premium support, patient population analytics, and more.\n
          Deploy Current Health system wide.\n\n${planDescriptions.join('\n')}`;
};

export const GET_DEMO_PLAN_GROUP_DESCRIPTION = (): string =>
  'Customizable plan --tailored to your --practice needs';

export const GET_DEMO_PLAN_GROUP_ID = (): string => 'DEMO_GROUP';

export const GET_DEMO_PLAN_GROUP_NAME = (): string =>
  'LARGE GROUP\n PRACTICE/HEALTH\n SYSTEM';

export const GET_SUITABLE_PLANS = (
  plans: PaymentPlanType[],
  code: string | null,
  planId: string | null,
): PaymentPlanType[] => {
  return (
    plans &&
    plans
      .filter((plan: PaymentPlanType) => {
        const commonConditions =
          plan.planId !== 'MenHealth.testsubscription' &&
          plan.planId !== 'PatientSelfMonitoringPlan' &&
          plan.planId !== 'SelfMonitoringPlan' &&
          !plan.planId.includes('Tier') &&
          !plan.planId.includes('DEMO');

        if (code && ['WEX', 'procept'].includes(code)) {
          return (
            commonConditions &&
            plan.planId === `1-${code.toUpperCase()}-PATIENT-self-plan`
          );
        } else {
          if (planId) {
            return plan.planId === planId;
          }

          return commonConditions && plan.planId === '1-PATIENT-self-plan';
        }
      })
      .map((p: PaymentPlanType) => ({
        ...p,
        planType: GET_USER_ROLE_TYPE_BY_PLAN_NAME(p.planId),
      }))
  );
};
